import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { FOOTER, LINKS, SITE } from '../lib/content';
import { Mark } from './LogoMark';

export function Footer() {
  return (
    <footer className="border-t" style={{ borderColor: 'var(--line)' }}>
      <div className="container-wide py-12 md:py-16">
        <div className="grid gap-12 md:grid-cols-[minmax(0,1fr)_auto_auto] md:gap-20">
          <div className="max-w-sm">
            <Link to="/" className="brand-lockup" aria-label="Morrow — home">
              <Mark className="brand-lockup__mark" />
              <span className="brand-lockup__word">Morrow</span>
            </Link>
            <p className="mt-5 max-w-xs text-sm leading-6 text-[color:var(--fg-3)]">
              {SITE.tagline} Self-hosted, provider-neutral, and local by default.
            </p>
          </div>

          {FOOTER.columns.map((column) => (
            <nav key={column.title} aria-label={column.title} className="flex flex-col items-start gap-3">
              <p className="credits-kicker">{column.title}</p>
              {column.links.map((link) =>
                link.external ? (
                  <a
                    key={link.label}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="credits-title inline-flex items-center gap-1 transition-colors hover:text-[color:var(--fg)]"
                  >
                    {link.label}
                    <ArrowUpRight className="h-3 w-3" aria-hidden="true" />
                  </a>
                ) : (
                  <Link
                    key={link.label}
                    to={link.href!}
                    className="credits-title transition-colors hover:text-[color:var(--fg)]"
                  >
                    {link.label}
                  </Link>
                ),
              )}
            </nav>
          ))}
        </div>

        <div
          className="mt-12 flex flex-col gap-3 border-t pt-6 text-xs text-[color:var(--fg-4)] sm:flex-row sm:items-center sm:justify-between"
          style={{ borderColor: 'var(--line)' }}
        >
          <span>© {new Date().getFullYear()} Morrow</span>
          <span className="mono">local-first · provider-neutral · self-hosted</span>
          <a
            href={LINKS.changelog}
            target="_blank"
            rel="noopener noreferrer"
            className="transition-colors hover:text-[color:var(--fg-2)]"
          >
            Changelog ↗
          </a>
        </div>
      </div>
    </footer>
  );
}
